module.exports = __webpack_public_path__ + "img/swipe.99ef9c04.png";